import { dxtToLocalServerTime } from "@dexteel/mesf-core";

export const formatNumber = (
	v: number | null | undefined,
	decimals = 0,
): string => {
	if (v == null) return "-";
	return Number(v.toFixed(decimals)).toLocaleString("en-US", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
};

export const formatDateTime = (d: Date | null): string =>
	d ? dxtToLocalServerTime(d, "MM/dd HH:mm") || "-" : "—";

export const cellStyle = {
	fontSize: "0.72rem",
	py: 0.35,
	px: 0.5,
	borderBottom: "1px solid #f0f0f0",
};

export const headerCellStyle = {
	...cellStyle,
	fontWeight: 600,
	color: "#555",
	borderBottom: "1px solid #ddd",
};

export const subCellStyle = {
	...cellStyle,
	fontSize: "0.7rem",
	color: "#555",
};

export const subHeaderCellStyle = {
	...subCellStyle,
	fontWeight: 600,
	color: "#888",
	textTransform: "uppercase" as const,
	letterSpacing: 0.3,
	borderBottom: "1px solid #eee",
};
